/*
 *** SERVER CONFIGURATIONS ***
 *
 *  Configurations for the Node server.
 */

import { env } from 'process';
import current from './env';
// const env = require('./env');

const staticPath = current.isProduction ? 'static' : '../static';

export default {
  // The path to serve static content from.
  staticPath,

  // The host name to use for the Node server
  host: env.HOST || 'localhost',

  // The port to start the Node server on
  port: env.PORT || 3000,

  // Indicates whether server-side rendering should be disabled or not.
  // I.e. if the React component tree should be hydrated server side or
  // only when loaded on the client.
  // Server side rendering helps with SEO and can speed up first load.
  disableSSR: false,

  // When SSR is enabled, the pages can't be cached to correctly create a new
  // Accedo One session if necessary. However, the files will still use cache.
  // When leaving it empty it will use the default by the CDN. For no cache you
  // can set it to `'no-cache'`.
  routesCacheValue: 'no-cache',

  // If we need an HTTP proxy to use for our client app, it can
  // be configured here. The below will proxy any call to
  // <server-url>/ovp to https://vdk-ovp.ocs.demo.accedo.tv
  //
  // Using a proxy can e.g. be an alternative in dev mode when you're not
  // in control of CORS settings on the server.
  // It can also be necessary if you need to attach confidential information
  // such as API tokens to OVP requests without exposing them to the client.
  //
  // Checkout src/server/middleware/proxy.js for hooking in to the request/response
  // chain of proxy requests.
  proxies: [
    {
      path: `/ovp`,
      // url: 'https://vdk-ovp.ocs.demo.accedo.tv'
      //url: 'https://accedoovp20x.ocs.ps.accedo.tv'
      url: 'https://ovp-api.ocs2.ps.accedo.tv/'
    },
    {
      path: `/brightcove-auth`,
      url: 'https://oauth.brightcove.com'
    },
    {
      path: `/brightcove-cms`,
      url: 'https://cms.api.brightcove.com'
    }
  ],

  // Settings for the server side logger.
  // These will be passed to the server side vdkweb-winston
  // logger in src/utils/logger.js
  logger: {
    // Defines the logging targets that we want to log
    // to whenever we're using the logger.
    transports: [
      // Logging to the console
      {
        name: 'Console',
        enabled: true
      }
    ]
  }
};
